import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';

import { InMailsFirestoreResponse } from '../../types';
import { fetchDocumentById } from '../utils';

const COLLECTION_PATH = 'inmails';

export const useGetInMailDocumentFromFirestore = (
  documentId: string | null | undefined,
  options?: UseQueryOptions<InMailsFirestoreResponse | null, FirebaseError>,
): UseQueryResult<InMailsFirestoreResponse | null, FirebaseError> => useQuery<
InMailsFirestoreResponse | null, FirebaseError>({
  queryKey: [`inmail-${documentId}`] as const,
  queryFn: async (): Promise<InMailsFirestoreResponse | null> => {
    const data = await fetchDocumentById<InMailsFirestoreResponse>(COLLECTION_PATH, documentId);
    return data ?? null;
  },
  enabled: !!documentId,
  retry: 0,
  ...options,
});
